/**
 * Verificando Status do boleto
 *
 * @export
 * @param {*} installment
 * @returns
 */
export function handleStatus(installment) {
  let currentDate = new Date();
  let dueDate = new Date(installment.dueDate);
  let status;
  dueDate.setDate(dueDate.getDate() + 1);
  if (installment.paymentStatus === "OP") {
    if (currentDate > dueDate) status = "Vencido";
    if (currentDate <= dueDate) status = "A Vencer";
  } else {
    status = "Pago";
  }
  return status;
}

export function convertLine(dados) {
  const line = `${dados}`;
  const bank = line.substring(0, 3);
  const coin = line.substring(3, 4);
  const camp = line.substring(4, 9);
  //const camp1 = line.substring(9, 10);
  const camp2 = line.substring(10, 20);
  //const camp3 = line.substring(20, 21);
  const camp4 = line.substring(21, 31);
  //const camp5 = line.substring(31, 32);
  const camp6 = line.substring(32, 47);
  const result = bank + coin + camp6 + camp + camp2 + camp4;
  return result;
}
